import { differenceInSeconds } from 'date-fns';

export const calculateTimeLeft = (expiryDate: Date) => {
  const secondsDiff = Math.max(0, differenceInSeconds(expiryDate, new Date()));

  return `${Math.floor(secondsDiff / 60)}:${String(secondsDiff % 60).padStart(
    2,
    '0',
  )}`;
};
